const TOKEN = 'token';
const REFRESH = 'refresh';
const EXPIRY = 'expiry';
const USER = 'user';

export { TOKEN, REFRESH, EXPIRY, USER };
